import React, { Component,Fragment } from 'react';
import { connect } from 'react-redux';
import { apiReport } from '../../store/actions/companyActions';
import 'rc-datetime-picker/dist/picker.css';
import Spinner from '../../components/Spinner';
class ModalReport extends Component {

	constructor(props){
		super(props);
		this.state = {
			loading: true
		}
	}

	componentDidMount() {
		this.props.apiReport(this.props.urlReport)
			.then(() => {
				this.setState({
					loading: false
				})
			});
	}

	componentWillUnmount() {
		this.props.apiReport(null);
	}

	render() {
		const { session, report, json_lang, companyColor } = this.props;
		const { loading } = this.state;

		if(loading){
			return <div className="d-flex justify-content-center align-items-center" style={{ height: "40vh" }}>
				<Spinner size='100px' color={companyColor} />
			</div>
		}

		if(!report){
			return <div className="d-flex justify-content-center align-items-center" style={{ height: "40vh" }}>
				<span className="font-xl">El reporte no se generó correctamente</span>
			</div>
		}

		const reportStatusStyle = {
			in_queue: "secondary",
			generating: "warning",
			failed: "danger",
			available: "success"
		}

		const iconStatus = {
			failed: "fa fa-times-circle",
			available: "fa fa-check-circle"
		}

		return <div style={{ height: "40vh" }}>
			<div className="flex-grow-0 d-flex flex-column justify-content-center align-items-center">
				<span className="font-xl">El reporte</span>
				<span className="font-weight-bold font-xl">{this.props.tittle}</span>
				<span className="font-xl">se generará y enviará al correo:</span>
				<span className="font-weight-bold font-xl">{session.email}</span>
			</div>
			<div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center h-100">
				{
					report.status !== "generating" ? (
						<Fragment>
							{
								report.status === "in_queue" ? (
									<Spinner size="50px" color={companyColor} />
								) : (
									<i className={`${iconStatus[report.status]} text-${reportStatusStyle[report.status]} font-4xl`} />
								)
							}
							<span className={`font-lg mt-2 badge badge-${reportStatusStyle[report.status]}`}>
								{json_lang.reports[report.status]}
							</span>
						</Fragment>
					) : (
						<Fragment>
							<div className="progress-bar-container">
								<div className="progress-bar-fill" style={{ width: `${report.progress}%` }}></div>
							</div>
							<span className="font-lg badge badge-warning mt-2">
								{report.progress.toFixed(2)}%
							</span>
						</Fragment>
					)
				}
				
			</div>
		</div>
	}
}


const mapStateToProps = (state) => ({
	session: state.session,
	json_lang: state.json_lang,
    report: state.report,
	companyColor: state.company.styles_json.styles.color_primary
})

const mapDispatchToProps = (dispatch) => ({
	apiReport:(url) => dispatch(apiReport(url)),
})


export default connect(mapStateToProps,mapDispatchToProps)(ModalReport);



// WEBPACK FOOTER //
// ./src/views/Reports/ModalReport.jsx